import { useQuery } from "@tanstack/react-query";
import { getLectureQuizQuestion } from "../../../../services/dashboard/apiQuizes";

export function useQuizQuestion({
  courseId,
  lectureId,
  itemId,
  questionId,
} = {}) {
  const { data: quizQuestion, isPending } = useQuery({
    queryKey: ["quizQuestionDB", courseId, lectureId, itemId, questionId],
    queryFn: () =>
      getLectureQuizQuestion({
        courseId,
        lectureId,
        itemId,
        questionId,
      }),
  });

  return { isPending, quizQuestion };
}
